import React from 'react'

import Dropzone from 'react-dropzone'

const Placeholder = ({ getInputProps, getRootProps, error, touched }) => (
  <div
    {...getRootProps()}
    className={`file-upload-placeholder placeholder-preview ${
      error && touched ? 'has-error' : ''
    }`}
  >
    <input {...getInputProps()} />

    <p className={'text-center'}>
      Click or drag image file to this area to upload.
    </p>
  </div>
)

export const renderDropzoneInput = ({
  handleOnDrop,
  input: { onChange },
  meta: { error, touched },
}) => {
  return (
    <Dropzone
      className="upload-container"
      onDrop={(file) => handleOnDrop(file, onChange)}
    >
      {({ getRootProps, getInputProps }) => (
        <Placeholder
          error={error}
          touched={touched}
          getInputProps={getInputProps}
          getRootProps={getRootProps}
        />
      )}
    </Dropzone>
  )
}
